import { Record, List } from 'immutable';
import ErrorRecord from '~/data/ErrorRecord';
import { SubMenuItem } from '~/data/SubmenuItem';

const keys: Fields = {
  isLoading: false,
  hasLoaded: false,
  submenuItems: List(),
  error: undefined,
};

export type UserManagementType = string;
export type UserManagementSubmenuItem = SubMenuItem<UserManagementType>;

interface Fields {
  isLoading: boolean;
  hasLoaded: boolean;
  submenuItems: List<UserManagementSubmenuItem>;
  error?: ErrorRecord;
}

export default class UserManagementSubmenuRecord extends Record<Fields>(keys) {
  constructor(values?) {
    super(values);

    let newInstance = this.asImmutable();
    if (values) {
      if (values.submenuItems) {
        newInstance = newInstance.set(
          'submenuItems',
          List(values.submenuItems)
        );
      }

      if (values.invitesSubmenuItem) {
        newInstance = newInstance.updateIn(['submenuItems'], submenuItems => {
          return submenuItems.push(values.invitesSubmenuItem);
        });
      }
    }

    return newInstance;
  }
}
